import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';

@NgModule({
  imports: [
    CommonModule,
    NzMenuModule,
    NzButtonModule,
    NzTableModule,
    NzLayoutModule,
    NzSpinModule,
    NzFormModule,
    NzIconModule,
    NzSwitchModule,
    NzModalModule,
    NzTooltipModule,
    NzSelectModule,
    NzRadioModule,
    NzProgressModule,
    NzDatePickerModule,
    NzNoAnimationModule,
    NzTabsModule,
    NzCheckboxModule,
    NzAvatarModule,
    NzStepsModule,
    NzImageModule,
    NzUploadModule,
    NzDrawerModule,
    NzDescriptionsModule,
    NzSegmentedModule,
    NzSliderModule,
    NzDividerModule,
    NzTimelineModule,
    NzInputModule,
    NzPaginationModule,
  ],
  exports: [
    NzMenuModule,
    NzButtonModule,
    NzTableModule,
    NzLayoutModule,
    NzSpinModule,
    NzFormModule,
    NzIconModule,
    NzSwitchModule,
    NzModalModule,
    NzTooltipModule,
    NzSelectModule,
    NzRadioModule,
    NzProgressModule,
    NzDatePickerModule,
    NzNoAnimationModule,
    NzTabsModule,
    NzCheckboxModule,
    NzAvatarModule,
    NzStepsModule,
    NzImageModule,
    NzUploadModule,
    NzDrawerModule,
    NzDescriptionsModule,
    NzSegmentedModule,
    NzSliderModule,
    NzDividerModule,
    NzTimelineModule,
    NzInputModule,
    NzPaginationModule,
  ],
})
export class NgZorroModule {}
